import Vue from 'vue'
import { store } from '../../components/front/vue/store/store'

if (document.querySelector('#pedigree-view')) {
    // Vue.component('pedigree-view', require('../../components/front/vue/Pedigree/Index.vue').default)

    const PedigreeView = () => import(/* webpackChunkName: "assets/pedigree-view" */ 'FrontComponents/vue/Pedigree/Index.vue')

    window.pedigreeComponent = new Vue({
        el: '#pedigree-view',
        store,
        components: {
            PedigreeView,
        },
    })
}

if (document.querySelector('#pedigree-registration')) {
    // Vue.component('pedigree-view', require('../../components/front/vue/Pedigree/Index.vue').default)

    const PedigreeRegistrationView = () => import(/* webpackChunkName: "assets/pedigree-view" */ 'FrontComponents/vue/Pedigree/Registration/Parents.vue')

    const PEDIGREE = new Vue({
        el: '#pedigree-registration',
        store,
        components: {
            PedigreeRegistrationView,
        },
    })
}
